import { apiFetch } from "./client";

export const fetchHomeProducts = () =>
  apiFetch("/enduser/home-products/", {
    credentials: "include",
  });
